"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.postGenericOrder = exports.postGenericCheckbankaccount = exports.postFormsubmitV4 = exports.postFormsubmitV2 = void 0;
/**
 * Submits form
 * @param data The data for the request.
 * @param data.requestBody
 * @returns FormSubmitResponse OK
 * @throws ApiError
 */
const postFormsubmitV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/generic/formsubmit/v2',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postFormsubmitV2 = postFormsubmitV2;
/**
 * New Generic Form endpoint for EIS
 * @param data The data for the request.
 * @param data.requestBody
 * @returns FormSubmitResponse OK
 * @throws ApiError
 */
const postFormsubmitV4 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/generic/formsubmit/v4',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postFormsubmitV4 = postFormsubmitV4;
/**
 * This service checks bank account requests
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CheckBankAccountResponse OK
 * @throws ApiError
 */
const postGenericCheckbankaccount = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/generic/checkBankAccount',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postGenericCheckbankaccount = postGenericCheckbankaccount;
/**
 * A lead order can be created, which a customer has to approve before it is picked up as a new customer request
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GenericOrderResponse OK
 * @throws ApiError
 */
const postGenericOrder = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/generic/order',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postGenericOrder = postGenericOrder;
